import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchInputComponent } from '@shared/components/search-input/search-input.component';
import { SvgModule } from '@shared/components/svg/svg.module';
import { LongPressModule } from '@shared/directives/long-press/long-press.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SearchInputComponent],
  imports: [CommonModule, SvgModule, LongPressModule, ReactiveFormsModule, NgLetModule, TranslateModule],
  exports: [SearchInputComponent]
})
export class SearchInputModule {}
